import React from 'react'
import Button from './buttons/Button'
import './style/InMind.css'
function InMind() {
    return (
        <div className="inMind" id="contact">
            <div className="inMind__text">
                <div>
                    <h3>Have Any Project in Mind</h3>
                    <p>Aute cupidatat quis deserunt excepteur esse Lorem do.</p>
                </div>
                <Button text="Hire Me"/>
            </div>
        </div>
    )
}

export default InMind
